export const messages = {
  en: {
     roomBindMeterArchive: {
        title: 'Room Bind Meter Archive',
        room: 'Room Information',
        roomPlaceholder: 'Please select room',
        meterArchive: 'Meter Archive',
        meterArchivePlaceholder: 'Please select meter archive',
        selectMeterArchive: 'Select Meter Archive',
        meterAddr: 'Meter Address',
        meterType: 'Meter Type',
        userName: 'User Name',
        startTime: 'Start Time',
        startTimePlaceholder: 'Please select start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Please select end time',
        remarks: 'Remarks',
        remarksPlaceholder: 'Please enter remarks (max 200 characters)',

        // 表类型
        waterMeter: 'Water Meter',
        electricMeter: 'Electric Meter',
        gasMeter: 'Gas Meter',
        otherMeter: 'Other Meter',

        // 验证消息
        meterArchiveRequired: 'Please select meter archive',
        roomRequired: 'Room information cannot be empty',
        startTimeRequired: 'Please select start time',
        endTimeRequired: 'Please select end time',
        timeError: 'End time must be greater than start time',

        // 操作消息
        fetchRoomError: 'Failed to get room information',
        bindSuccess: 'Bind successfully',
        bindFailed: 'Bind failed'
      },
    searchMeterArchive: {
        title: 'Search Meter Archive',
        meterAddrPlaceholder: 'Please enter meter address',
        userNamePlaceholder: 'Please enter user name',
        roomPlaceholder: 'Please enter room number',
        meterTypePlaceholder: 'Please select meter type',
        meterAddr: 'Meter Address',
        userName: 'User Name',
        userCode: 'User Code',
        roomName: 'Room Name',
        meterType: 'Meter Type',
        balance: 'Balance',
        onlineState: 'Online State',
        valveState: 'Valve State',
        lastConTime: 'Last Connection Time',
        waterMeter: 'Water Meter',
        electricMeter: 'Electric Meter',
        unknownType: 'Unknown Type',
        online: 'Online',
        offline: 'Offline',
        valveOpen: 'Open',
        valveClose: 'Close',
        valveException: 'Exception'
      }
  },
  zh: {
    roomBindMeterArchive: {
        title: '房屋绑定水表档案',
        room: '房屋信息',
        roomPlaceholder: '请选择房屋',
        meterArchive: '表档案',
        meterArchivePlaceholder: '请选择表档案',
        selectMeterArchive: '选择表档案',
        meterAddr: '表地址',
        meterType: '表类型',
        userName: '用户姓名',
        startTime: '开始时间',
        startTimePlaceholder: '请选择开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '请选择结束时间',
        remarks: '备注信息',
        remarksPlaceholder: '请输入备注信息（最多200字）',

        // 表类型
        waterMeter: '水表',
        electricMeter: '电表',
        gasMeter: '燃气表',
        otherMeter: '其他表',

        // 验证消息
        meterArchiveRequired: '请选择表档案',
        roomRequired: '房屋信息不能为空',
        startTimeRequired: '请选择开始时间',
        endTimeRequired: '请选择结束时间',
        timeError: '结束时间必须大于开始时间',

        // 操作消息
        fetchRoomError: '获取房屋信息失败',
        bindSuccess: '绑定成功',
        bindFailed: '绑定失败'
      },
    searchMeterArchive: {
        title: '查询表档案',
        meterAddrPlaceholder: '请输入表地址',
        userNamePlaceholder: '请输入用户姓名',
        roomPlaceholder: '请输入房间号',
        meterTypePlaceholder: '请选择表类型',
        meterAddr: '表地址',
        userName: '用户姓名',
        userCode: '用户编号',
        roomName: '已绑房屋',
        meterType: '表类型',
        balance: '剩余量',
        onlineState: '在线状态',
        valveState: '阀门状态',
        lastConTime: '最后通讯时间',
        waterMeter: '水表',
        electricMeter: '电表',
        unknownType: '未知类型',
        online: '在线',
        offline: '离线',
        valveOpen: '开启',
        valveClose: '关闭',
        valveException: '异常'
      }
  }
}